/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type PatchContactPersonToCustomerV1Dto = {
  /**
   * The current version of the entity
   */
  version: number;
  /**
   * The uuid of the contact-person linked to this relation. As 8-4-4-4-12 format.
   */
  contactPersonId: string;
  /**
   * The uuid of the customer linked to this relation. As 8-4-4-4-12 format.
   */
  customerId: string;
  /**
   * Role of the contact person in the customer
   */
  role?: PatchContactPersonToCustomerV1Dto.role | null;
  /**
   * Job title of the contact person in the customer
   */
  jobTitle?: string | null;
};
export namespace PatchContactPersonToCustomerV1Dto {
  /**
   * Role of the contact person in the customer
   */
  export enum role {
    OWNER = 'Owner',
    TENANT = 'Tenant',
    PROPERTY_MANAGER = 'PropertyManager',
    FACILITY_MANAGER = 'FacilityManager',
    SERVICE_PROVIDER = 'ServiceProvider',
    OTHER = 'Other',
  }
}
